import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import SalaryFileDatatableRowMeta from "@Modules/cardManagementSystem/prepaid/containers/formHandlers/company/salaryFile/SalaryFileDatatableRowMeta";

export type TSalaryFileDataTableData = {
    primaryKey: string | number,
    idBatch: string,
    intgDate: string,
    added: string,
    salary: string,
    returned: string,
    canceled: string,
    procDate: string,
    idBank: string,
    status: string,

    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TSalaryFileDataTableData>()

export function getSalaryFileDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("idBatch",
        {
            id: "idBatch",
            header: "Batch ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("intgDate",
        {
            id: "intgDate",
            header: "Date Intg",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),    
    columnHelper.accessor("added",
        {
            id: "added",
            header: "Ajout",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("salary",
        {
            id: "salary",
            header: "Salaire",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("returned",
        {
            id: "returned",
            header: "Restitué",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("canceled",
        {
            id: "canceled",
            header: "Annulé",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("procDate",
        {
            id: "procDate",
            header: "Date Proc.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("idBank",
        {
            id: "idBank",
            header: "ID Banque",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
       
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <Button
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            mr={'1rem'}
                        >
                            Editer
                        </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
